// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"41":"038470a6","292":"2ac96c35","650":"809ffe78","787":"a542a446","808":"b87c6360"}[chunkId] + ".chunk.js";
};